import LargeModal from "../../../component/LargeModel";
import React, {useState} from "react";
import {Button, Form} from "react-bootstrap";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import axios from "axios";
import {ApiUrl} from "../../../auth/authMethods";
import displayAlertMsg from "../../../component/AlertMsg/displayAlertMsg";
import AlertMsg from "../../../component/AlertMsg/AlertMsg";

const Impersonate = ({item, setLoadData}) => {
    const [lgShow, setLgShow] = useState(false);
    const [error, setError] = useState(false);

    const buttonText = <>
        <ForwardToInboxIcon fontSize="medium"/>
        &nbsp; Reenviar boas vindas
    </>;

    const iconSpan = (
        <ForwardToInboxIcon style={{fontSize: 100}} id="icon-svg"/>
    );

    const handleSubmit = (e) => {
        e.preventDefault();

        setError(false)

        axios.put(ApiUrl + "/user/resend-welcome/" + item.id)
            .then((response) => {
                setLgShow(false)
            }).catch((error) => {
            console.log(error);
            setError(true)
        })
    };

    return (
        <>
            <LargeModal
                buttonClass={"dropdown-item"}
                buttonText={buttonText}
                title={`Realmente deseja reenviar o "boas vindas" para: ${item.username}?`}
                iconSpan={iconSpan}
                lgShow={lgShow} setLgShow={setLgShow}
                buttonId={"links-action"}
            >
                <div className="message-container">
                    <span><b>Atenção</b></span>
                    <hr/>
                    <div className="message-content">
                        <p>
                            Ao confirmar esta ação, será gerada uma nova senha para este usuário e tanto o email quanto
                            o whatsapp (caso possua número cadastrado) de boas vindas serão reenviados.
                        </p>
                    </div>
                    <hr/>
                </div>

                {error && <div className='text-center'>
                    <AlertMsg/>
                </div>}
                <div>
                    <Form onSubmit={handleSubmit} className="form-inputs">
                        <Button type="submit" className="btn">
                            Confirmar Reenvio
                        </Button>
                    </Form>
                </div>

            </LargeModal>
        </>
    );
};

export default Impersonate;
